module.exports = __webpack_public_path__ + "static/media/image-gallery-10.bf5eb6cd.jpg";